const i18n = {
  'selectTagsDialog': {
    'title': '選擇標籤',
    'selectedTags': '已選擇的標籤: ',
    'search': '搜尋標籤',
  }
};
export default i18n;
